import { green, orange } from '@ant-design/colors'
import { SignatureOutlined } from '@ant-design/icons'
import { CampaignEmployee as CampaignEmployeeModel } from '@models/Campaign'
import { Card, Progress, Space, Tag } from 'antd'
import dayjs from 'dayjs'
import { Employee } from '../employee/Employee'
import { CampaignEmployee } from './CampaignEmployee'
import { CampaignEmployeeStatus } from './Status'

interface Props {
  campaignEmployee?: CampaignEmployeeModel
  readonly?: boolean
}

export const CampaignManagerCard = ({
  campaignEmployee,
  readonly = false,
}: Props) => {
  if (!campaignEmployee) {
    return <></>
  }

  return (
    <Card>
      <Space className="w-full space-between">
        <Employee.Avatar model={campaignEmployee.employee} />
        <Space>
          <Progress
            type="dashboard"
            percent={campaignEmployee.managerProgression.progression}
            size={35}
            strokeColor={
              campaignEmployee.managerProgression.progression == 100
                ? green[4]
                : orange[4]
            }
          />
          <Tag
            color={campaignEmployee.managerSignedAt ? 'green' : 'orange'}
            icon={<SignatureOutlined />}
          >
            {campaignEmployee.managerSignedAt
              ? dayjs(campaignEmployee.managerSignedAt).fromNow()
              : 'Non signé'}
          </Tag>
          <CampaignEmployeeStatus
            role="manager"
            campaignEmployee={campaignEmployee}
            readonly={readonly}
          />
          <CampaignEmployee.Download campaignEmployeeId={campaignEmployee.id} />
        </Space>
      </Space>
    </Card>
  )
}

export type CampaignManagerCardType = {
  ManagerCard: typeof CampaignManagerCard
}
